<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.00006 12.5334L16.0001 20.5334L24.0001 12.5334L22.1334 10.6667L16.0001 16.8001L9.86673 10.6667L8.00006 12.5334Z"
      fill="white"
    />
  </svg>
</template>
